import script from "./overview.vue?vue&type=script&lang=ts&setup=true"
export * from "./overview.vue?vue&type=script&lang=ts&setup=true"

import "./overview.vue?vue&type=style&index=0&id=9ebd1c4a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ebd1c4a"]])

export default __exports__